import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { FontScaleProvider } from './contexts/FontScaleContext';
import { ToastProvider } from './components/base/Toast';
import { ConfirmProvider } from './components/base/Confirm';
import PwaInstallPrompt from './components/feature/PwaInstallPrompt';
import PwaLocationGuide from './components/feature/PwaLocationGuide';
import LogoutOverlay from './components/feature/LogoutOverlay';
import PageTransitionOverlay from './components/feature/PageTransitionOverlay';
import FontScalePrompt from './components/feature/FontScalePrompt';
import MorningReminderPrompt from './components/feature/MorningReminderPrompt';
import AppUpdateBanner from './components/feature/AppUpdateBanner';
import MenuOverlayHost from './components/feature/MenuOverlayHost';
import ItAvailabilityAlert from './components/feature/ItAvailabilityAlert';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <FontScaleProvider>
          <ToastProvider>
            <ConfirmProvider>
              <AppRoutes />
              <MenuOverlayHost />
              <FontScalePrompt />
              <MorningReminderPrompt />
              <AppUpdateBanner />
              <PwaInstallPrompt />
              <PwaLocationGuide />
              <PageTransitionOverlay />
              <LogoutOverlay />
              <ItAvailabilityAlert />
            </ConfirmProvider>
          </ToastProvider>
        </FontScaleProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;